module.exports = __webpack_public_path__ + "img/search-ranking-area-empty.73a0ee75.png";